import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { theme } from "../genie-theme/genie-theme";
import useUser from "../../../queries/routes/useUser";
import { purchasingRedirect } from "../../../utils/redirects";

interface GenieLogoProps {
  isSmall?: boolean;
}
function GenieLogo({ isSmall = false }: GenieLogoProps) {
  const { data: user } = useUser();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  if (!user) {
    return null;
  }
  return (
    <Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        component={Link}
        to={user ? purchasingRedirect(user) : "/"}
      >
        <Box
          component={"img"}
          height={isMobile || isSmall ? "42px" : "35px"}
          sx={{ backgroundSize: "cover" }}
          width={isMobile || isSmall ? "42px" : "100%"}
          src={
            isMobile || isSmall
              ? `/assets/genie_logo_small.svg`
              : `/assets/genie_logo_long.svg`
          }
          alt={"Logo"}
        />
      </Box>
    </Box>
  );
}

export default GenieLogo;
